import {PenLine} from "../../types";
import {ShapeConfig} from "konva/types/Shape";
import React from "react";
import isEqual from "lodash/isEqual";
import {Line} from "react-konva";

type BasePenElementKonvaProps = {
	visible: boolean,
	line: PenLine,
	style: ShapeConfig,
	eventsRef: React.MutableRefObject<BasePenEventHandlers>
}

export type BasePenEventHandlers = {
	onMouseEnter?: () => void,
	onMouseLeave?: () => void,
	onClick?: () => void,
	onTap?: () => void
}

function averagePressure(pressures: number[]): number {
	if (!pressures.length) return 1
	return pressures.reduce((sum, p) => sum + p, 0) / pressures.length
}

const _BasePenElementKonva = function({
	visible,
	line,
	style,
	eventsRef
}: BasePenElementKonvaProps) {

	function onMouseEnter() {
		eventsRef.current.onMouseEnter?.()
	}

	function onMouseLeave() {
		eventsRef.current.onMouseLeave?.()
	}

	function onClick() {
		eventsRef.current.onClick?.()
	}

	function onTap() {
		eventsRef.current.onTap?.()
	}

	const pressureStrokeWidth = line.pressures && line.pressures.length > 0
		? (style.strokeWidth ?? 2) * Math.max(0.5, averagePressure(line.pressures) * 1.5)
		: undefined

	return (
		<Line
			id={line.id}
			points={line.points}
			visible={visible}
			{...style}
			strokeWidth={pressureStrokeWidth ?? style.strokeWidth}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			onClick={onClick}
			onTap={onTap}
		/>
	)
}

export const BasePenElementKonva = React.memo(_BasePenElementKonva, isEqual)
